import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TOCOpen {
    isOpen: boolean;
}
const initialState: TOCOpen = {
    isOpen: false,
};
const TOCOpenSlice = createSlice({
    name: 'TOCOpen',
    initialState,
    reducers: {
        setTOCOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setTOCOpen } = TOCOpenSlice.actions;
export default TOCOpenSlice.reducer;
